var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.AddEditClientTAT == 0) ? _c('div', {
    staticClass: "card-header filter_main",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.AddEditClientTAT = '1'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus plus"
  }), _vm._v("Add Remittance TAT\n                ")]) : _vm._e(), _vm._v(" "), (_vm.AddEditClientTAT == 1) ? _c('div', {
    staticClass: "card-header filter_main",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.AddEditClientTAT = '0'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus minus"
  }), _vm._v("Add Remittance TAT\n                ")]) : _vm._e(), _vm._v(" "), _c('b-collapse', {
    class: ("" + (_vm.AddEditClientTAT == '1' ? 'show' : 'hide')),
    attrs: {
      "id": "collapse1"
    }
  }, [(_vm.addformshow == 1) ? _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    attrs: {
      "id": "formSubmit",
      "name": "formSubmit"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Client Name "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.clientLoading
    },
    on: {
      "update:active": function($event) {
        _vm.clientLoading = $event
      }
    }
  }), _vm._v(" "), _c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'error': _vm.errors.has('ClientId')
    },
    staticStyle: {
      "border": "1px solid #c2cfd6",
      "z-index": "1000"
    },
    attrs: {
      "options": _vm.ClientList,
      "name": "ClientId",
      "id": "ClientId",
      "placeholder": "Select Client",
      "label": "CompanyName",
      "track-by": "ClientMasterID",
      "optionHeight": 100,
      "hide-selected": true
    },
    on: {
      "input": function($event) {
        _vm.GetClientBusinessConfigList()
      }
    },
    model: {
      value: (_vm.ClientId),
      callback: function($$v) {
        _vm.ClientId = $$v
      },
      expression: "ClientId"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_c('p', [_vm._v("No Record Found.")])])], 2)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ClientId')),
      expression: "errors.has('ClientId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Client is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Bussiness Service Type "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.businessLoading
    },
    on: {
      "update:active": function($event) {
        _vm.businessLoading = $event
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Bussinesstype),
      expression: "Bussinesstype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('Bussinesstype')
    },
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "name": "Bussinesstype",
      "id": "Bussinesstype"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.Bussinesstype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.GetClientBusinessAccounts]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.ClientBusinessList), function(Client_obj) {
    return _c('option', {
      domProps: {
        "value": Client_obj.ClientBusinessDetailID
      }
    }, [_vm._v(_vm._s(Client_obj.BusinessConfig))])
  })], 2)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Bussinesstype')),
      expression: "errors.has('Bussinesstype')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Bussiness type is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Account Name "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.accountLoading
    },
    on: {
      "update:active": function($event) {
        _vm.accountLoading = $event
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AccountName),
      expression: "AccountName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('AccountName')
    },
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "name": "AccountName",
      "id": "AccountName"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.AccountName = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getAccountDetails]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.ClientAccountsList), function(Client_obj) {
    return _c('option', {
      domProps: {
        "value": Client_obj.ClientBusinessAccountId
      }
    }, [_vm._v(_vm._s(Client_obj.AccountName))])
  })], 2)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('AccountName')),
      expression: "errors.has('AccountName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Account name is required.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Remittance Day "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'error': _vm.errors.has('RemittanceDay')
    },
    staticStyle: {
      "border": "1px solid #c2cfd6",
      "z-index": "999"
    },
    attrs: {
      "options": _vm.RemittanceDayList,
      "name": "RemittanceDay",
      "id": "RemittanceDay",
      "placeholder": "Select Remittance Day",
      "label": "day",
      "track-by": "day",
      "preselect-first": false,
      "multiple": _vm.multiple(),
      "max-height": 150,
      "optionHeight": 100,
      "hide-selected": true
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.RemittanceDay),
      callback: function($$v) {
        _vm.RemittanceDay = $$v
      },
      expression: "RemittanceDay"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_c('p', [_vm._v("No Record Found.")])])], 2)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('RemittanceDay')),
      expression: "errors.has('RemittanceDay')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Remittance day is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Remittance TAT "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tat),
      expression: "tat"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('tat')
    },
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "name": "tat",
      "id": "tat"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tat = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("T+2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("T+3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("T+4")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tat')),
      expression: "errors.has('tat')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Remittance TAT is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Client Type "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('type')
    },
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "name": "type",
      "id": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Hybrid"
    }
  }, [_vm._v("Hybrid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Non-Hybrid"
    }
  }, [_vm._v("Non-Hybrid")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('type')),
      expression: "errors.has('type')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Client type is required.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Beneficiary Name ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.bankDLoading
    },
    on: {
      "update:active": function($event) {
        _vm.bankDLoading = $event
      }
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Enter Beneficiary Name",
      "name": "Beneficiary",
      "id": "Beneficiary"
    },
    model: {
      value: (_vm.Beneficiary),
      callback: function($$v) {
        _vm.Beneficiary = $$v
      },
      expression: "Beneficiary"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Beneficiary')),
      expression: "errors.has('Beneficiary')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Beneficiary Name is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bank Name ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.bankDLoading
    },
    on: {
      "update:active": function($event) {
        _vm.bankDLoading = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BankName),
      expression: "BankName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Bank Name",
      "name": "BankName",
      "id": "BankName",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.BankName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.BankName = $event.target.value
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('BankName')),
      expression: "errors.has('BankName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Bank Name is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bank Account No ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.bankDLoading
    },
    on: {
      "update:active": function($event) {
        _vm.bankDLoading = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BankAccount),
      expression: "BankAccount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Bank Account No",
      "name": "BankAccount",
      "id": "BankAccount",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.BankAccount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.BankAccount = $event.target.value
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('BankAccount')),
      expression: "errors.has('BankAccount')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Bank Account No is required.")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("RTGS / IFSC ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.bankDLoading
    },
    on: {
      "update:active": function($event) {
        _vm.bankDLoading = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rtgs),
      expression: "rtgs"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "rtgs",
      "type": "text",
      "placeholder": "Enter RTGS/IFSC",
      "name": "rtgs",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.rtgs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rtgs = $event.target.value
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rtgs')),
      expression: "errors.has('rtgs')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("RTGS / IFSC is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Contact Email Id")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.bankDLoading
    },
    on: {
      "update:active": function($event) {
        _vm.bankDLoading = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ContactEmailid),
      expression: "ContactEmailid"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "ContactEmailid",
      "type": "text",
      "placeholder": "Enter Contact Email Id",
      "name": "ContactEmailid",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.ContactEmailid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ContactEmailid = $event.target.value
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Tally COD Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.bankDLoading
    },
    on: {
      "update:active": function($event) {
        _vm.bankDLoading = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tallycodname),
      expression: "tallycodname"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tallycodname",
      "type": "text",
      "placeholder": "Enter Tally COD Name",
      "name": "tallycodname",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.tallycodname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tallycodname = $event.target.value
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Tally Freight Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.bankDLoading
    },
    on: {
      "update:active": function($event) {
        _vm.bankDLoading = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tallyfreightname),
      expression: "tallyfreightname"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tallyfreightname",
      "type": "text",
      "placeholder": "Enter Tally Freight Name",
      "name": "tallyfreightname",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.tallyfreightname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tallyfreightname = $event.target.value
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Sales Person Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.bankDLoading
    },
    on: {
      "update:active": function($event) {
        _vm.bankDLoading = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salespersonname),
      expression: "salespersonname"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "salespersonname",
      "type": "text",
      "placeholder": "Enter Sales Person Name",
      "name": "salespersonname",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.salespersonname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.salespersonname = $event.target.value
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Status "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.IsActive),
      expression: "IsActive"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.errors.has('IsActive')
    },
    attrs: {
      "name": "IsActive",
      "id": "IsActive"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.IsActive = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "In Active"
    }
  }, [_vm._v("In Active")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('IsActive')),
      expression: "errors.has('IsActive')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Status is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('label', [_vm._v("Require Cancel cheque")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "36px"
    },
    attrs: {
      "left": "<i class='fa fa-file-text'></i>"
    }
  }, [_c('input', {
    ref: "paymentfile",
    class: {
      'form-control': true,
      'error': _vm.errors.has('paymentfile')
    },
    attrs: {
      "type": "file",
      "placeholder": "Require Cancel cheque",
      "accept": ".jpg, .png",
      "name": "paymentfile",
      "id": "paymentfile"
    },
    on: {
      "change": function($event) {
        _vm.onUpload()
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Note: * Only accept .png or .jpg upto 1 MB.")])], 1), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('paymentfile')),
      expression: "errors.has('paymentfile')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Upload file is required.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.submitLoading
    },
    on: {
      "update:active": function($event) {
        _vm.submitLoading = $event
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "name": "submit",
      "id": "submit",
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Clear")])], 1)])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Client "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.clientLoading
    },
    on: {
      "update:active": function($event) {
        _vm.clientLoading = $event
      }
    }
  }), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "options": _vm.ClientAccountList,
      "name": "Client",
      "id": "Client",
      "placeholder": "Select Client",
      "label": "AccountName",
      "track-by": "AccountId",
      "data-ClientId": _vm.ClientId,
      "optionHeight": 100,
      "hide-selected": true
    },
    model: {
      value: (_vm.Client),
      callback: function($$v) {
        _vm.Client = $$v
      },
      expression: "Client"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_c('p', [_vm._v("No Record Found.")])])], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "clienterr"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer",
    on: {
      "click": function($event) {
        _vm.AddEditClientTAT = '0'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Clear")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Result\n                    "), (_vm.resultCount != 0) ? _c('button', {
    staticClass: "btn btn-sm btn-success ",
    staticStyle: {
      "float": "right",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportToExcel
    }
  }, [_vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    class: ("" + (_vm.resultCount==0 ? 'scrolltbl' : 'scrolltb'))
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listClientCODRemittanceData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.pageno + index + 1))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.AccountName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.TAT))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.RemittanceDayString))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.RemittanceType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.BeneficiaryName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ClientBankName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ClientAccountNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.NEFTNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CustomerMailId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.tallycodname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.tallyfreightname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.salespersonname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.IsActive) + "\n                            ")]), _vm._v(" "), _c('td', [(data.cancelCheque && data.cancelCheque != 0) ? _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25, 25, 112)",
        "text-decoration": "underline"
      },
      attrs: {
        "href": data.cancelCheque,
        "target": "_blank"
      }
    }, [_vm._v("view")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-edit text-successedit fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getSVCRowData(data, _vm.resultCount)
        }
      }
    })])])
  })], 2)]), _c('br'), _vm._v(" "), (_vm.resultCount > 1) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '«',
      "next-text": '»',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.edithide == 2) ? _c('b-modal', {
    ref: "myClosureModalRef",
    attrs: {
      "no-close-on-backdrop": true,
      "id": "myModal"
    },
    on: {
      "hidden": _vm.closeStatusRoleModal
    },
    model: {
      value: (_vm.updateModal),
      callback: function($$v) {
        _vm.updateModal = $$v
      },
      expression: "updateModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "width": "185%",
      "margin-left": "-25%"
    }
  }, [_c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onUpdate()
      }
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(" Edit Remittance TAT")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Client Name ")]), _c('br'), _vm._v(" "), _c('b', [_c('label', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.clientname))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Account Name ")]), _c('br'), _vm._v(" "), _c('b', [_c('label', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.accountname))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Remittance Day "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'error': _vm.errors.has('RemittanceDayedit')
    },
    staticStyle: {
      "border": "1px solid #c2cfd6",
      "z-index": "999"
    },
    attrs: {
      "options": _vm.RemittanceDayListedit,
      "name": "RemittanceDayedit",
      "id": "RemittanceDayedit",
      "placeholder": "Select Remittance Day",
      "label": "day",
      "track-by": "day",
      "preselect-first": false,
      "multiple": _vm.multiple(),
      "max-height": 150,
      "optionHeight": 100,
      "hide-selected": true
    },
    on: {
      "select": _vm.handleSelectedit
    },
    model: {
      value: (_vm.RemittanceDayedit),
      callback: function($$v) {
        _vm.RemittanceDayedit = $$v
      },
      expression: "RemittanceDayedit"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_c('p', [_vm._v("No Record Found.")])])], 2)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('RemittanceDayedit')),
      expression: "errors.has('RemittanceDayedit')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Remittance day is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Remittance TAT "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tatedit),
      expression: "tatedit"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('tat')
    },
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "name": "tatedit",
      "id": "tatedit"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tatedit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("T+2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("T+3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("T+4")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tatedit')),
      expression: "errors.has('tatedit')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Remittance TAT is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Client Type "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeedit),
      expression: "typeedit"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('type')
    },
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "name": "typeedit",
      "id": "typeedit"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeedit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Hybrid"
    }
  }, [_vm._v("Hybrid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Non-Hybrid"
    }
  }, [_vm._v("Non-Hybrid")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('typeedit')),
      expression: "errors.has('typeedit')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Client type is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Beneficiary Name ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.bankDLoading
    },
    on: {
      "update:active": function($event) {
        _vm.bankDLoading = $event
      }
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Enter Beneficiary Name",
      "name": "Beneficiaryedit",
      "id": "Beneficiaryedit"
    },
    model: {
      value: (_vm.Beneficiaryedit),
      callback: function($$v) {
        _vm.Beneficiaryedit = $$v
      },
      expression: "Beneficiaryedit"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Beneficiaryedit')),
      expression: "errors.has('Beneficiaryedit')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Beneficiary Name is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bank Name ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.bankDLoading
    },
    on: {
      "update:active": function($event) {
        _vm.bankDLoading = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BankNameedit),
      expression: "BankNameedit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Bank Name",
      "name": "BankNameedit",
      "id": "BankNameedit",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.BankNameedit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.BankNameedit = $event.target.value
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('BankNameedit')),
      expression: "errors.has('BankNameedit')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Bank Name is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bank Account No ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.bankDLoading
    },
    on: {
      "update:active": function($event) {
        _vm.bankDLoading = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BankAccountedit),
      expression: "BankAccountedit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Bank Account No",
      "name": "BankAccountedit",
      "id": "BankAccountedit",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.BankAccountedit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.BankAccountedit = $event.target.value
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('BankAccountedit')),
      expression: "errors.has('BankAccountedit')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Bank Account No is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("RTGS / IFSC ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.bankDLoading
    },
    on: {
      "update:active": function($event) {
        _vm.bankDLoading = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rtgsedit),
      expression: "rtgsedit"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "rtgs",
      "type": "text",
      "placeholder": "Enter RTGS/IFSC",
      "name": "rtgsedit",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.rtgsedit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rtgsedit = $event.target.value
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rtgsedit')),
      expression: "errors.has('rtgsedit')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("RTGS / IFSC is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Contact Email Id")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.bankDLoading
    },
    on: {
      "update:active": function($event) {
        _vm.bankDLoading = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ContactEmailidedit),
      expression: "ContactEmailidedit"
    }],
    staticClass: "form-control ",
    attrs: {
      "id": "ContactEmailidedit",
      "type": "text",
      "placeholder": "Enter Contact Email Id",
      "name": "ContactEmailidedit",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.ContactEmailidedit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ContactEmailidedit = $event.target.value
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('label', [_vm._v("Tally COD Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.bankDLoading
    },
    on: {
      "update:active": function($event) {
        _vm.bankDLoading = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tallycodnameEdit),
      expression: "tallycodnameEdit"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tallycodnameEdit",
      "type": "text",
      "placeholder": "Enter Tally COD Name",
      "name": "tallycodnameEdit",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.tallycodnameEdit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tallycodnameEdit = $event.target.value
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('label', [_vm._v("Tally Freight Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.bankDLoading
    },
    on: {
      "update:active": function($event) {
        _vm.bankDLoading = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tallyfreightnameEdit),
      expression: "tallyfreightnameEdit"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tallyfreightnameEdit",
      "type": "text",
      "placeholder": "Enter Tally Freight Name",
      "name": "tallyfreightnameEdit",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.tallyfreightnameEdit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tallyfreightnameEdit = $event.target.value
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('label', [_vm._v("Sales Person Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.bankDLoading
    },
    on: {
      "update:active": function($event) {
        _vm.bankDLoading = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salespersonnameEdit),
      expression: "salespersonnameEdit"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "salespersonnameEdit",
      "type": "text",
      "placeholder": "Enter Sales Person Name",
      "name": "salespersonnameEdit",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.salespersonnameEdit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.salespersonnameEdit = $event.target.value
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('label', [_vm._v("Status "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.IsActiveEdit),
      expression: "IsActiveEdit"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "IsActiveEdit",
      "id": "IsActiveEdit"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.IsActiveEdit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Active",
      "title": "Active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "In Active",
      "title": "In Active"
    }
  }, [_vm._v("In Active")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('IsActiveEdit')),
      expression: "errors.has('IsActiveEdit')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Status is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('label', [_vm._v("Require Cancel cheque")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "36px"
    },
    attrs: {
      "left": "<i class='fa fa-file-text'></i>"
    }
  }, [_c('input', {
    ref: "paymentfiles",
    class: {
      'form-control': true,
      'error': _vm.errors.has('paymentfile')
    },
    attrs: {
      "type": "file",
      "placeholder": "Require Cancel cheque",
      "accept": ".jpg, .png",
      "name": "paymentfile",
      "id": "paymentfile"
    },
    on: {
      "change": function($event) {
        _vm.onUploadedit()
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Note: * Only accept .png or .jpg upto 1 MB.")])], 1), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('paymentfile')),
      expression: "errors.has('paymentfile')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Upload file is required.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer text-center"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.submitLoading
    },
    on: {
      "update:active": function($event) {
        _vm.submitLoading = $event
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Close")])], 1)])])], 1)])])])])]) : _vm._e()], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Export Client Master")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Company Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("TAT")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Remittance Day")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Remittance Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Beneficiary Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Bank Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Account No")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("IFSC")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Mail Id")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Tally COD Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Tally Freight Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Sales Person Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Cancel Cheque")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f5111e8","hasScoped":true}!./src/views/components/AddEditClientTAT/AddEditClientTAT.component.html
// module id = 638
// module chunks = 1